import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { getDownloads, getLoading } from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByDownloads,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'
@Component({
    selector: 'app-aggregated-amounts-download-unit',
    templateUrl: './aggregated-amounts-download-unit.component.html',
    styleUrls: ['./aggregated-amounts-download-unit.component.scss'],
    standalone: false
})
export class AggregatedAmountsDownloadUnitComponent implements OnInit {
  downloadUnitSummary$: Observable<CountableSummary>
  loading$: Observable<boolean>
  selectedArtist$: Observable<Artist>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.downloadUnitSummary$ = this.store.select(getDownloads)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByDownloads)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
